// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.Sidebar_container__7S6En {
  width: 340px;
  height: 100vh;
  background-color: var(--sb-bg-color);
  border: 1px solid var(--sb-bg-color);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 340px;
  position: sticky;
  z-index: 3;
}
.Sidebar_container__7S6En a {
  text-decoration: none;
  color: unset;
}
.Sidebar_container__7S6En .Sidebar_logo__MK9UY {
  padding: 22px 0 0 28px;
}
.Sidebar_container__7S6En .Sidebar_logo__MK9UY img {
  width: 51px;
  height: 36px;
}
@media (max-width: 780px) {
  .Sidebar_container__7S6En {
    display: none;
  }
}

.Sidebar_list__IbHNL {
  list-style-type: none;
}
.Sidebar_list__IbHNL .Sidebar_listItem__RUbfg {
  border-radius: 12px;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--font-dark-color);
  gap: 8px;
  padding: 7px 0 5px 8px;
  margin-bottom: 12px;
}
.Sidebar_list__IbHNL .Sidebar_listItem__RUbfg span {
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.Sidebar_list__IbHNL .Sidebar_listItem__RUbfg img {
  width: 30px;
  height: 30px;
}
@media (max-width: 780px) {
  .Sidebar_list__IbHNL .Sidebar_listItem__RUbfg span {
    font-family: Red Hat Display;
    font-size: 16px;
  }
}
.Sidebar_list__IbHNL .Sidebar_listItem__RUbfg:hover,
.Sidebar_list__IbHNL .Sidebar_active__Iy\\+kJ {
  background-color: var(--hover-bg-color);
  color: var(--font-color);
  font-weight: 700;
}
@media (max-width: 780px) {
  .Sidebar_list__IbHNL .Sidebar_listItem__RUbfg {
    padding: 7px 0 5px 9px;
  }
}

.Sidebar_wrapper__x7vqh {
  color: #7c7c7d;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 17px 27px 20px 26px;
}
@media (max-width: 780px) {
  .Sidebar_wrapper__x7vqh {
    justify-content: initial;
    padding: 23px 0 0 0;
  }
  .Sidebar_wrapper__x7vqh .Sidebar_secondList__so1KY {
    margin-top: 0 !important;
  }
}

.Sidebar_menu__oIHBL {
  color: var(--font-dark-color);
  text-align: left;
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding-left: 6px;
  margin-bottom: 8px;
}

.Sidebar_option__blinb .Sidebar_setting__0vd7z {
  width: 100%;
  height: 102px;
  border-radius: 7px;
  background: var(--set-bg-color);
  padding: 11px 16px 14px 14px;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z div {
  display: flex;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_info__2wWV5 img {
  width: 30px;
  height: 30px;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_info__2wWV5 span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  margin-left: 10px;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_info__2wWV5 div {
  width: 63px;
  height: 24px;
  border-radius: 52px;
  display: flex;
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-left: auto;
  justify-content: center;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM {
  margin-top: 13px;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM button {
  width: 94px;
  height: 34px;
  border-radius: 6px;
  display: flex;
  padding: 5px 9px;
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.15px;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM button svg {
  margin-right: 8px;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM .Sidebar_light__yi4EW {
  background: var(--light-bg-color);
  color: var(--font-light-color);
  border: 1px solid var(--light-bg-color);
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM .Sidebar_light__yi4EW:hover {
  opacity: 0.7;
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM .Sidebar_dark__FFOMp {
  background: var(--dark-bg-btn-color);
  color: var(--font-dark-btn-color);
  margin-left: 7px;
  border: 1px solid var(--dark-bg-btn-color);
}
.Sidebar_option__blinb .Sidebar_setting__0vd7z .Sidebar_color__mvEZM .Sidebar_dark__FFOMp:hover {
  opacity: 0.7;
}
.Sidebar_option__blinb .Sidebar_button__4WSyv {
  display: flex;
  margin-top: 11px;
}
.Sidebar_option__blinb .Sidebar_button__4WSyv a {
  width: 94px;
  height: 26px;
  border-radius: 9px;
  display: flex;
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  justify-content: center;
}
.Sidebar_option__blinb .Sidebar_button__4WSyv .Sidebar_logout__IaW-k {
  background: var(--logout-bg-color);
  color: #e85454;
}
.Sidebar_option__blinb .Sidebar_button__4WSyv .Sidebar_logout__IaW-k:hover {
  opacity: 0.7;
}
.Sidebar_option__blinb .Sidebar_button__4WSyv .Sidebar_support__Ffb\\+a {
  background: var(--support-bg-color);
  color: #111315;
  font-weight: 700;
  margin-left: 8px;
}
.Sidebar_option__blinb .Sidebar_button__4WSyv .Sidebar_support__Ffb\\+a:hover {
  opacity: 0.7;
}

@media (max-width: 781px) {
  .Sidebar_option__blinb {
    margin-top: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/components/Layouts/DashboardLayout/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AA4CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,6BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,yBAAA;EACA,4CAAA;AC3CF;AArCA;EACE,YAAA;EACA,aAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAuCF;AArCE;EACE,qBAAA;EACA,YAAA;AAuCJ;AApCE;EACE,sBAAA;AAsCJ;AApCI;EACE,WAAA;EACA,YAAA;AAsCN;AAlCE;EA1BF;IA2BI,aAAA;EAqCF;AACF;;AAlCA;EACE,qBAAA;AAqCF;AAnCE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;AAqCJ;AAnCI;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAqCN;AAlCI;EACE,WAAA;EACA,YAAA;AAoCN;AAjCI;EACE;IACE,4BAAA;IACA,eAAA;EAmCN;AACF;AA/BE;;EAEE,uCAAA;EACA,wBAAA;EACA,gBAAA;AAiCJ;AA9BE;EACE;IACE,sBAAA;EAgCJ;AACF;;AA5BA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,4BAAA;AA+BF;AA7BE;EARF;IASI,wBAAA;IACA,mBAAA;EAgCF;EA9BE;IACE,wBAAA;EAgCJ;AACF;;AA5BA;EACE,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA+BF;;AA3BE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,+BAAA;EACA,4BAAA;AA8BJ;AA5BI;EACE,aAAA;AA8BN;AA1BM;EACE,WAAA;EACA,YAAA;AA4BR;AAzBM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AA2BR;AAxBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;AA0BR;AAtBI;EACE,gBAAA;AAwBN;AAtBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAwBR;AAtBQ;EACE,iBAAA;AAwBV;AApBM;EACE,iCAAA;EACA,8BAAA;EACA,uCAAA;AAsBR;AAnBM;EACE,YAAA;AAqBR;AAlBM;EACE,oCAAA;EACA,iCAAA;EACA,gBAAA;EACA,0CAAA;AAoBR;AAjBM;EACE,YAAA;AAmBR;AAdE;EACE,aAAA;EACA,gBAAA;AAgBJ;AAdI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAgBN;AAbI;EACE,kCAAA;EACA,cAAA;AAeN;AAZI;EACE,YAAA;AAcN;AAXI;EACE,mCAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAaN;AAVI;EACE,YAAA;AAYN;;AAPA;EACE;IACE,eAAA;EAUF;AACF","sourcesContent":["// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import '/src/assets/stylesheets/variables';\n\n.container {\n  width: 340px;\n  height: 100vh;\n  background-color: var(--sb-bg-color);\n  border: 1px solid var(--sb-bg-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: 340px;\n  position: sticky;\n  z-index: 3;\n\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n\n  .logo {\n    padding: 22px 0 0 28px;\n\n    img {\n      width: 51px;\n      height: 36px;\n    }\n  }\n\n  @media (max-width: 780px) {\n    display: none;\n  }\n}\n\n.list {\n  list-style-type: none;\n\n  .listItem {\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: var(--font-dark-color);\n    gap: 8px;\n    padding: 7px 0 5px 8px;\n    margin-bottom: 12px;\n\n    span {\n      font-family: Red Hat Display;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    img {\n      width: 30px;\n      height: 30px;\n    }\n\n    @media (max-width: 780px) {\n      span {\n        font-family: Red Hat Display;\n        font-size: 16px;\n      }\n    }\n  }\n\n  .listItem:hover,\n  .active {\n    background-color: var(--hover-bg-color);\n    color: var(--font-color);\n    font-weight: 700;\n  }\n\n  @media (max-width: 780px) {\n    .listItem {\n      padding: 7px 0 5px 9px;\n    }\n  }\n}\n\n.wrapper {\n  color: #7c7c7d;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  padding: 17px 27px 20px 26px;\n\n  @media (max-width: 780px) {\n    justify-content: initial;\n    padding: 23px 0 0 0;\n\n    .secondList {\n      margin-top: 0 !important;\n    }\n  }\n}\n\n.menu {\n  color: var(--font-dark-color);\n  text-align: left;\n  font-family: Red Hat Display;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  padding-left: 6px;\n  margin-bottom: 8px;\n}\n\n.option {\n  .setting {\n    width: 100%;\n    height: 102px;\n    border-radius: 7px;\n    background: var(--set-bg-color);\n    padding: 11px 16px 14px 14px;\n\n    div {\n      display: flex;\n    }\n\n    .info {\n      img {\n        width: 30px;\n        height: 30px;\n      }\n\n      span {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 30px;\n        margin-left: 10px;\n      }\n\n      div {\n        width: 63px;\n        height: 24px;\n        border-radius: 52px;\n        display: flex;\n        font-family: Red Hat Display;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 24px;\n        margin-left: auto;\n        justify-content: center;\n      }\n    }\n\n    .color {\n      margin-top: 13px;\n\n      button {\n        width: 94px;\n        height: 34px;\n        border-radius: 6px;\n        display: flex;\n        padding: 5px 9px;\n        font-family: Red Hat Display;\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 22px;\n        letter-spacing: -0.15px;\n\n        svg {\n          margin-right: 8px;\n        }\n      }\n\n      .light {\n        background: var(--light-bg-color);\n        color: var(--font-light-color);\n        border: 1px solid var(--light-bg-color);\n      }\n\n      .light:hover {\n        opacity: 0.7;\n      }\n\n      .dark {\n        background: var(--dark-bg-btn-color);\n        color: var(--font-dark-btn-color);\n        margin-left: 7px;\n        border: 1px solid var(--dark-bg-btn-color);\n      }\n\n      .dark:hover {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  .button {\n    display: flex;\n    margin-top: 11px;\n\n    a {\n      width: 94px;\n      height: 26px;\n      border-radius: 9px;\n      display: flex;\n      font-family: Red Hat Display;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n      justify-content: center;\n    }\n\n    .logout {\n      background: var(--logout-bg-color);\n      color: #e85454;\n    }\n\n    .logout:hover {\n      opacity: 0.7;\n    }\n\n    .support {\n      background: var(--support-bg-color);\n      color: #111315;\n      font-weight: 700;\n      margin-left: 8px;\n    }\n\n    .support:hover {\n      opacity: 0.7;\n    }\n  }\n}\n\n@media (max-width: 781px) {\n  .option {\n    margin-top: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Sidebar_container__7S6En`,
	"logo": `Sidebar_logo__MK9UY`,
	"list": `Sidebar_list__IbHNL`,
	"listItem": `Sidebar_listItem__RUbfg`,
	"active": `Sidebar_active__Iy+kJ`,
	"wrapper": `Sidebar_wrapper__x7vqh`,
	"secondList": `Sidebar_secondList__so1KY`,
	"menu": `Sidebar_menu__oIHBL`,
	"option": `Sidebar_option__blinb`,
	"setting": `Sidebar_setting__0vd7z`,
	"info": `Sidebar_info__2wWV5`,
	"color": `Sidebar_color__mvEZM`,
	"light": `Sidebar_light__yi4EW`,
	"dark": `Sidebar_dark__FFOMp`,
	"button": `Sidebar_button__4WSyv`,
	"logout": `Sidebar_logout__IaW-k`,
	"support": `Sidebar_support__Ffb+a`
};
export default ___CSS_LOADER_EXPORT___;
